import { message } from 'antd';
import { takeLatest, put } from 'redux-saga/effects';
import { logger } from 'services';
import { createDocumentTemplatePrivateSectionAction } from '../actions';
import { createDocumentTemplateSection } from '../slices';
function* createDocumentTemplatePrivateSectionSaga(action) {
    const { payload: { docId } } = action;
    try {
        const section = {
            content: '<p></p>',
            documentSectionId: 0,
            meta: {
                sectionType: 'PRIVATE',
                resourceSections: []
            },
            createdAt: +new Date()
        };
        yield put(createDocumentTemplateSection({
            templateId: docId,
            section
        }));
    } catch (error) {
        logger.error('an error creating a private section in the document', {
            error
        });
        message.error('There was an error creating a private section in the document');
    }
}
export function* watchCreateDocumentTemplatePrivateSectionSaga() {
    yield takeLatest(createDocumentTemplatePrivateSectionAction.type, createDocumentTemplatePrivateSectionSaga);
}
